<template>
  <div class="bq-product-emar">
    <SectionTitle :title="'产品简介'"></SectionTitle>
    <p class="title-desc">
      eMAR（Electronic Medical Administration
      Record）为电子用药记录，不仅是患者的住院期间用药记录，而是一个完整的用药整合系统，包含院前用药、长期或临时医嘱、手术用药、出院带药，所有用药信息结构化，系统会对药物、食物、检验之间的配伍禁忌和药物的累积使用剂量进行智能化提醒。
    </p>
    <div class="emar-descs">
      <InfoBox
        :col="3"
        :itemObj="item"
        v-for="item in list"
        :key="item.advTitles"
      ></InfoBox>
    </div>
    <SectionTitle :title="'产品优势'"></SectionTitle>
    <div class="emar-adv">
      <InfoBox
        :col="2"
        :itemObj="item"
        v-for="item in datalist"
        :key="item.advTitles"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'emar',
  data() {
    return {
      list: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1nn5jF4D1gK0jSZFyXXciOVXa-96-96.png',
          advTitles: '展示用药情况',
          advDesc:
            '展示患者院内院外的所有用药情况。院内用药根据服药方式分为口服药、外用药、注射药和其他这四个维度。院内用药情况包含服用药品的规格、用法用量、服用时间、药品的累积使用剂量、开药科室和开嘱医生。其中药品的累积使用剂量包含当前累积剂量和总体累积剂量。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1MXajF7T2gK0jSZPcXXcKkpXa-96-96.png',
          advTitles: '数据互通',
          advDesc:
            'eMAR会与互联网医院内的用药助手产品进行数据互通，将患者院外用药情况导入eMAR， 由于院外数据的质量无法确保，在eMAR中单独有院外用药的模块，同时也有汇总查询模块，在此模块里可查到患者院内院外所有用药记录。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1kbmfF4n1gK0jSZKPXXXvUXXa-96-96.png',
          advTitles: '图表展示',
          advDesc:
            'eMAR用图表的形式来形象展示患者院内院外的用药情况，帮助医生快速了解患者既往用药情况，同时确保患者在药物治疗过程中得到正确的药物、正确的剂量、正确的用药途径。',
        },
      ],
      datalist: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1qBKiF4v1gK0jSZFFXXb0sXXa-96-96.png',
          advTitles: '院内外打通',
          advDesc: '院内院外用药情况的打通，可查看患者全生命周期的用药情况；',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1SYqfFVP7gK0jSZFjXXc5aXXa-96-96.png',
          advTitles: '累积量统计',
          advDesc:
            '对药品进行累积量的统计，可供医生、药师等开药的时候进行合理用药的参考。',
        },
      ],
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
.bq-product-emar {
  width: 1200px;
  margin: 0 auto;
  .title-desc {
    color: #333;
    font-size: 18px;
  }

  .emar-descs {
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    .bq-infobox {
      width: 352px !important;
    }
  }

  .emar-adv {
    display: flex;
    justify-content: space-between;
    margin-bottom: 60px;
    .bq-infobox {
      width: 562px !important;
    }
  }

  /deep/ .bq-infobox {
    p {
      font-size: 18px;
    }
  }
}
</style>
